if (!customElements.get('gift-country-modal')) {
  customElements.define(
    'gift-country-modal',
    class GiftCountryModal extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-country-open]');
        this.shell = this.querySelector('.gift-country-modal__shell');
        this.select = this.querySelector('[data-country-select]');
        this.closeButtons = this.querySelectorAll('[data-country-close]');

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);

        this.trigger?.addEventListener('click', this.open);
        this.closeButtons.forEach((button) => button.addEventListener('click', this.close));
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.open);
        this.closeButtons?.forEach((button) => button.removeEventListener('click', this.close));
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      onDocumentClick(event) {
        const trigger = event.target.closest?.('[data-country-open-external]');
        if (trigger) this.open({ currentTarget: trigger });
      }

      open(event) {
        this.activeTrigger = event?.currentTarget || this.trigger;
        this.shell.hidden = false;
        this.activeTrigger?.setAttribute('aria-expanded', 'true');
        document.body.classList.add('gift-country-modal-open');
        this.select?.focus({ preventScroll: true });
        requestAnimationFrame(() => {
          if (document.activeElement !== this.select) this.select?.focus({ preventScroll: true });
        });
      }

      close() {
        this.shell.hidden = true;
        this.activeTrigger?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('gift-country-modal-open');
        this.activeTrigger?.focus();
      }

      onKeydown(event) {
        if (event.key === 'Escape' && !this.shell?.hidden) this.close();
      }
    }
  );
}
